/**
 * Arquivo responsável pela ação de exibir pending orders no mapa.
 * @author: adalto.junior
 * Date: 09/12/13
 * Time: 14:25
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.PendingOrders = (function () {

    function PendingOrders () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'pending_order';
        this.RESOURCE_LAYER = 'Greenmile.MapLayerControl.pendingOrder';

        this.removeLayersOnTheMap = function () {

            var poGeneralFunctions = new Greenmile.MarkerPendingOrder.GeneralFunctions();
            poGeneralFunctions.setMap(this.map);
            poGeneralFunctions.removeAllMarkers();

        };

        this.addMarkersToMap = function (pendingOrders) {

            var cluster = new L.MarkerClusterGroup({
                spiderfyOnMaxZoom: true, 
                spiderfyDistanceMultiplier: 3
            });
            var pendingOrdersLength = pendingOrders.size();
            var poGeneralFunctions = new Greenmile.MarkerPendingOrder.GeneralFunctions();

            this.removeLayersOnTheMap();

            for (let i = 0; i < pendingOrdersLength; i++) {

                const model = pendingOrders.at(i);
                const location = model.get('location');
                if(location.latitude && location.longitude) {
                    const marker = poGeneralFunctions.createMarker(model);
                    if (marker._latlng) {
                        cluster.addLayer(marker);
                        cluster.kind = poGeneralFunctions.TEXT_KIND_CLUSTER;
                    }
                }
            }

            this.map.addLayer(cluster);

        };

        this.getPendingOrdersAndShowOnTheMap = function () {

            var collection = new App.Collections.PendingOrders();
            var filter = Greenmile.PendingOrdersNotification.Utils.filterBasic;
            var fieldsToProjection = Greenmile.PendingOrdersNotification.Utils.fieldsToProjection;
            var projectionBuilder = new Monet.Builder.Projection();
            var that = this;

            projectionBuilder.addFields(fieldsToProjection);

            collection.filterWithRestrictions({
                filter: filter,
                criteria: projectionBuilder.projection.toString(),
                success: function (result) {

                    if (result) {
                        that.addMarkersToMap(result);
                    }

                }
            });
        };

        this.afterClickOnCheckBox = function (context) {

            return function (element) {

                var status = false;
                var _element = this;

                if (element.type === 'checkbox') {
                    _element = element;
                }

                if (_element.checked) {

                    status = true;
                    context.getPendingOrdersAndShowOnTheMap();

                } else {

                    context.removeLayersOnTheMap();

                }

                context.setLayerStatusOnLocalStorageByTagName(status);
                Monet.Session.PendingOrdersNotification.mapLayerIsChecked = status;

            };

        }(this);

        this.render = function () {

            var itemList = document.createElement('li');
            var divLabel = document.createElement('div');
            var divCheckBox = document.createElement('div');
            var label = document.createElement('label');
            var checkBox = document.createElement('input');
            var layerIsChecked = this.getLayerStatusOnLocalStorage();

            const checkboxId = this.routeId ? this.LAYER_NAME + '_' + this.routeId : this.LAYER_NAME;
            checkBox.id = checkboxId;
            checkBox.name = this.LAYER_NAME;
            checkBox.type = 'checkbox';
            checkBox.removeEventListener('click', this.afterClickOnCheckBox);
            checkBox.addEventListener('click', this.afterClickOnCheckBox);

            divCheckBox.className = 'radio';
            divCheckBox.appendChild(checkBox);

            label.setAttribute('for', checkboxId);
            label.innerHTML = Monet.I18n.getResourcesByKey(this.RESOURCE_LAYER);

            divLabel.className = 'text';
            divLabel.appendChild(label);

            itemList.appendChild(divCheckBox);
            itemList.appendChild(divLabel);

            if (layerIsChecked) {
                checkBox.checked = 'checked';
            }

            return itemList;

        };


    }

    return PendingOrders;

}());